export { checkboxType, checkboxInputType, checkboxLabelType } from './CheckboxSpecs';
